// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createPayment_container__JqWQ- {
  animation: createPayment_init__U7epP 0.5s both;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 16px;
}

/*---Title---*/
.createPayment_container__JqWQ- .createPayment_titleContainer__kGBJI {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.createPayment_container__JqWQ- .createPayment_titleContainer__kGBJI h4 {
  width: 95%;
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 15px;
}

.createPayment_container__JqWQ- .createPayment_titleContainer__kGBJI .createPayment_arrow__y6TEp {
  transition: 0.3s;
}

.createPayment_container__JqWQ- .createPayment_titleContainer__kGBJI .createPayment_arrow__y6TEp:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ {
  animation: createPayment_init3__QLt-0 0.5s both 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_barcode__OfaWB {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_barcode__OfaWB form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_barcode__OfaWB form input {
  width: 100%;
  border: 1px solid rgba(128, 128, 128, 0.407);
  background-color: transparent;
  border-radius: 3px;
  padding-left: 10px;
  height: 47px;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_barcode__OfaWB form input:focus {
  background-color: white;
  border: 1px solid gray;
  outline: none;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_barcode__OfaWB form input:hover {
  border: 1px solid gray;
  outline: none;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ .createPayment_send__623v7 {
  animation: createPayment_init2__6LM11 0.5s both 1s;
  margin-top: 30px;
  width: 90%;
  height: 3.5rem;
}

.createPayment_container__JqWQ- .createPayment_form__sQ-b\\+ p {
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

.createPayment_container__JqWQ- .createPayment_icon__nB7MQ {
  transition: 0.3s;
}

.createPayment_container__JqWQ- .createPayment_icon__nB7MQ:hover {
  transition: 0.3s;
  filter: brightness(1.1);
  scale: 1.1;
  cursor: pointer;
}

@keyframes createPayment_init__U7epP {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes createPayment_init2__6LM11 {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes createPayment_init3__QLt-0 {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Pagos/create/createPayment.module.css"],"names":[],"mappings":"AAAA;EACE,8CAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kDAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  font-size: 16px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 15px;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .form {\n  animation: init3 0.5s both 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .barcode {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .form .barcode form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n}\n\n.container .form .barcode form input {\n  width: 100%;\n  border: 1px solid rgba(128, 128, 128, 0.407);\n  background-color: transparent;\n  border-radius: 3px;\n  padding-left: 10px;\n  height: 47px;\n}\n\n.container .form .barcode form input:focus {\n  background-color: white;\n  border: 1px solid gray;\n  outline: none;\n}\n\n.container .form .barcode form input:hover {\n  border: 1px solid gray;\n  outline: none;\n}\n\n.container .form .send {\n  animation: init2 0.5s both 1s;\n  margin-top: 30px;\n  width: 90%;\n  height: 3.5rem;\n}\n\n.container .form p {\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.container .icon {\n  transition: 0.3s;\n}\n\n.container .icon:hover {\n  transition: 0.3s;\n  filter: brightness(1.1);\n  scale: 1.1;\n  cursor: pointer;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `createPayment_container__JqWQ-`,
	"init": `createPayment_init__U7epP`,
	"titleContainer": `createPayment_titleContainer__kGBJI`,
	"arrow": `createPayment_arrow__y6TEp`,
	"form": `createPayment_form__sQ-b+`,
	"init3": `createPayment_init3__QLt-0`,
	"barcode": `createPayment_barcode__OfaWB`,
	"send": `createPayment_send__623v7`,
	"init2": `createPayment_init2__6LM11`,
	"icon": `createPayment_icon__nB7MQ`
};
export default ___CSS_LOADER_EXPORT___;
